/**
 * Normalize a trading-key commitment to 64 lowercase hex digits.
 * @param {string} input
 * @returns {string}
 */
export function normalizeCommitmentHex(input) {
  const hex = String(input || "")
    .trim()
    .replace(/^0x/i, "")
    .toLowerCase();
  if (!/^[0-9a-f]{64}$/.test(hex)) {
    throw new Error("Commitment must be 64 lowercase hex digits");
  }
  return hex;
}

/**
 * Parse `#/trader/:hex`, `#/agent/:hex`, or `#/agents` route segments.
 * @param {string[]} parts Hash path split on `/` (no leading `#`).
 * @returns {{ name: "trader" | "agent", commitmentHex: string } | { name: "agents" } | null}
 */
export function parseCommitmentRoute(parts) {
  const segment = parts[0];
  if (segment === "trader" && parts[1]) {
    return { name: "trader", commitmentHex: normalizeCommitmentHex(parts[1]) };
  }
  if (segment === "agent" && parts[1]) {
    return { name: "agent", commitmentHex: normalizeCommitmentHex(parts[1]) };
  }
  if (segment === "agents") {
    return { name: "agents" };
  }
  return null;
}
